// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"117ff496","628":"984bd9da"}[chunkId] + ".chunk.js";
};